import { render, staticRenderFns } from "./pgcDelete.vue?vue&type=template&id=4cbf6734&scoped=true"
import script from "./pgcDelete.vue?vue&type=script&lang=js"
export * from "./pgcDelete.vue?vue&type=script&lang=js"
import style0 from "./pgcDelete.vue?vue&type=style&index=0&id=4cbf6734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbf6734",
  null
  
)

export default component.exports